import axios from 'axios'
import store from '../store';

export default {
    get: (filters) => axios.post('events/guests', filters),
    store: (data) => axios.post('events/guests/store', data),
    update: (data) => axios.post('events/guests/update', data),
    delete: (id) => axios.post('events/guests/delete', id),
    send: (data) => axios.post('events/guests/send', data),
    sendReminder: (data) => axios.post('events/guests/send', data),
    sendInvitation: (data) => axios.post('events/guests/send-invitation', data),
    sendMasive: (data) => axios.post('events/guests/send-masive', data),
    sendMasiveReminder: (data) => axios.post('events/guests/send-masive', data),
    sendMasiveInvitation: (data) => axios.post('events/guests/send-masive-invitation', data),
    sendMasiveMessage: (data) => axios.post('events/guests/send-masive-message', data),
    sendTableMessage: (data) => axios.post('events/guests/send-table-message', data),
    sendSaveTheDate: (data) => axios.post('events/guests/send-save-the-date', data),
    sendPreInvitation: (data) => axios.post('events/guests/send-preinvitation', data),
    sendEventReminderMedia: (data) => axios.post('events/guests/send-event-reminder', data),
    cooldownStatus: (data) => axios.post('events/guests/cooldown-status', data),
    confirm: (data) => axios.post('events/guests/confirm', data),
    assignTable: (data) => axios.post('events/guests/assign-table', data),
    getTemplate: (importType = 'upsert') => axios.get('events/guests/download-template', { params: { import_type: importType } }).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        }
        else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),
    validateImport: (data) => axios.post('events/guests/validate-import', data),
    import: (data) => axios.post('events/guests/import', data),
    getImportHistory: (data) => axios.post('events/guests/import-history', data),
    getImportHistoryDetail: (data) => axios.post('events/guests/import-history-detail', data),
    downloadImportHistorySource: (data) => axios.post('events/guests/import-history-download-source', data),
    undoImport: (data) => axios.post('events/guests/undo-import', data),
    downloadExcel: (filters) => axios.post('events/guests/download-excel', filters).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        }
        else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),
    sendExcelEmail: (data) => axios.post('events/guests/send-excel-email', data),
    lastExcelEmailHistory: (data) => axios.post('events/guests/last-excel-email-history', data),
    downloadRecord: (data) => axios.post('events/guests/download-record', data).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        }
        else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    //Historial
    getHistory: (data) => axios.post('events/guests/history', data),
    getConversation: (data) => axios.post('events/guests/conversation', data),
    getBlacklist: (filters) => axios.post('events/guests/blacklist', filters),

    //Boletos con QR
    downloadTickets: (data) => axios.post('events/guests/download-tickets', data).then(res => {
        window.open(res.data.download_url, '_blank')
    }),
    downloadExcelAttendance: (data) => axios.post('events/guests/download-excel-attendance', data).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        }
        else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    //Scanear boleto
    scanTicket: (data) => axios.post('events/guests/scan-ticket', data),

    //Enviar boletos por email
    sendTickets: (data) => axios.post('events/guests/send-tickets', data),
    sendMasiveTickets: (data) => axios.post('events/guests/send-masive-tickets', data),

    //Descarga externa de boletos
    getDownloadExternalTickets: (token) => axios.get(`/events/download/tickets/${token}`),
    
}